import { put, takeLatest } from 'redux-saga/effects';
import { setTutorApiEndpoint } from '../chatbot/services/serviceConfig';
import { getOrganization } from '../crud/organization.crud';
import { getTenantOverride } from '../utils/tenantOverride';
import { REDUCER_ORGANIZATION } from './conf';

export const actionTypes = {
  SetOrganization: 'organization/SET_ORGANIZATION',
  GetOrganization: 'organization/GET_ORGANIZATION',
  // SetFeatureFlags: 'organization/SET_FEATURE_FLAGS',
  // GetFeatureFlags: 'organization/GET_FEATURE_FLAGS',
};

const initialState = {
  lms: null,
  tenant: null,
  googleClientId: null,
  // featureFlags: {
  //   [FEATURE_FLAGS.SHOW_IMMERSIVE_READER]: false,
  //   [FEATURE_FLAGS.SHOW_LEMONADE_FEEDBACK_GENERATOR]: false,
  //   [FEATURE_FLAGS.QUESTION_GENERATED_WITH_AI]: false,
  //   [FEATURE_FLAGS.SHOW_CREATE_VIDEOLESSON]: false,
  //   [FEATURE_FLAGS.FEEDBACK_GENERATED_WITH_AI]: false,
  //   [FEATURE_FLAGS.SHOW_CUSTOM_AVATAR]: false,
  //   [FEATURE_FLAGS.ALLOW_MOVE_SESSIONS]: false,
  //   [FEATURE_FLAGS.SHOW_POWER_LESSON]: false,
  //   [FEATURE_FLAGS.SHOW_SELECT_TYPE_LESSON]: false,
  //   [FEATURE_FLAGS.SHOW_INFANTILE_01]: false,
  // },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SetOrganization: {
      const { lms, tenant } = action.payload;
      return { ...state, lms: { ...lms }, tenant: tenant.guid, tenantData: tenant, googleClientId: tenant.googleClientId ?? null };
    }

    // case actionTypes.SetFeatureFlags: {
    //   return { ...state, featureFlags: { ...state.featureFlags, ...action.payload } };
    // }

    default:
      return state;
  }
};

// Cache del tenant compuesto con el override dev activo (ver getTenant). El sentinel inicial
// garantiza el primer cómputo aunque tenantData empiece como undefined.
let overriddenTenantBase = Symbol('unset');
let overriddenTenantValue;

export const selectors = {
  getLms: (state) => {
    return state[REDUCER_ORGANIZATION].lms;
  },
  getEntryPoint: (state) => {
    return state[REDUCER_ORGANIZATION].lms?.entryPoint;
  },
  getClient: (state) => {
    return getTenantOverride()?.client ?? state[REDUCER_ORGANIZATION].tenant;
  },
  getTenant: (state) => {
    const override = getTenantOverride();
    const tenantData = state[REDUCER_ORGANIZATION].tenantData;
    if (!override) return tenantData;
    // `state.tenant` (getClient) and `tenantData.guid` are the same value (see SetOrganization),
    // so an overridden client must also show through `tenant?.guid` — code like
    // useDataCalendar gates client-specific views on it. Everything else (lang_id, name, ...)
    // stays real unless the override provides its own tenantData.
    // The composed object is cached per tenantData identity: useSelector compares by
    // reference, and a fresh object on every call re-fires any effect with `tenant` in its
    // deps on every render (useAssessmentResultView looped onGetUsers infinitely, freezing
    // the results view whenever the dev override was active).
    if (overriddenTenantBase !== tenantData) {
      overriddenTenantBase = tenantData;
      overriddenTenantValue = {
        ...tenantData,
        ...(override.client ? { guid: override.client } : {}),
        ...override.tenantData,
      };
    }
    return overriddenTenantValue;
  },
  getGoogleClientId: (state) => {
    return state[REDUCER_ORGANIZATION].googleClientId;
  },
  getCanCreateCourse: (state) => {
    return state[REDUCER_ORGANIZATION].lms?.canCreateCourse;
  },
  getCanCreateGroup: (state) => {
    return state[REDUCER_ORGANIZATION].lms?.canCreateGroup;
  },
  // getFeatureFlag: (state, flag) => {
  //   return state[REDUCER_ORGANIZATION].featureFlags[flag];
  // },
  // getFeatureFlags: (state) => {
  //   return state[REDUCER_ORGANIZATION].featureFlags;
  // },
};

export const actions = {
  getOrganization: () => ({ type: actionTypes.GetOrganization, payload: {} }),
  setOrganization: (params) => ({ type: actionTypes.SetOrganization, payload: params }),
  // setFeatureFlags: (flags) => ({ type: actionTypes.SetFeatureFlags, payload: flags }),
  // getFeatureFlags: () => ({ type: actionTypes.GetFeatureFlags, payload: {} }),
};

export function* saga() {
  yield takeLatest(actionTypes.GetOrganization, function* getOrganizationSaga() {
    const { data } = yield getOrganization();

    if (data && data.status === 'success' && data.data) {
      // La clave llega en PascalCase: es el contrato de GET /organization, no una errata.
      setTutorApiEndpoint(data.data.tenant?.TutorApiEndpoint);
      yield put(actions.setOrganization(data.data));
      // Llamar directamente a getFeatureFlags después de setOrganization
      // yield put(actions.getFeatureFlags());
    }
  });

  // yield takeLatest(actionTypes.GetFeatureFlags, function* getOrganizationSaga() {
  //   const isImmersiveReaderEnabled = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.SHOW_IMMERSIVE_READER);
  //   const showLemonadeFeedbackGenerator = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.SHOW_LEMONADE_FEEDBACK_GENERATOR);
  //   const isQuestionGeneratedWithAI = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.QUESTION_GENERATED_WITH_AI);
  //
  //   const allowMoveSessions = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.ALLOW_MOVE_SESSIONS);
  //   const showPowerLesson = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.SHOW_POWER_LESSON);
  //   const showSelectTypeLesson = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.SHOW_SELECT_TYPE_LESSON);
  //   const showInfantile01 = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.SHOW_INFANTILE_01);
  //   const showCreateVideolesson = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.SHOW_CREATE_VIDEOLESSON);
  //   const showFeedbackGeneratedWithAI = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.FEEDBACK_GENERATED_WITH_AI);
  //   const showCustomAvatar = yield call([posthog, posthog.getFeatureFlag], FEATURE_FLAGS.SHOW_CUSTOM_AVATAR);
  //   yield put(
  //     actions.setFeatureFlags({
  //       [FEATURE_FLAGS.SHOW_IMMERSIVE_READER]: Boolean(isImmersiveReaderEnabled),
  //       [FEATURE_FLAGS.SHOW_LEMONADE_FEEDBACK_GENERATOR]: Boolean(showLemonadeFeedbackGenerator),
  //       [FEATURE_FLAGS.QUESTION_GENERATED_WITH_AI]: Boolean(isQuestionGeneratedWithAI),
  //       [FEATURE_FLAGS.SHOW_CREATE_VIDEOLESSON]: Boolean(showCreateVideolesson),
  //       [FEATURE_FLAGS.FEEDBACK_GENERATED_WITH_AI]: Boolean(showFeedbackGeneratedWithAI),
  //       [FEATURE_FLAGS.SHOW_CUSTOM_AVATAR]: Boolean(showCustomAvatar),
  //
  //       [FEATURE_FLAGS.ALLOW_MOVE_SESSIONS]: Boolean(allowMoveSessions),
  //       [FEATURE_FLAGS.SHOW_POWER_LESSON]: Boolean(showPowerLesson),
  //       [FEATURE_FLAGS.SHOW_SELECT_TYPE_LESSON]: Boolean(showSelectTypeLesson),
  //       [FEATURE_FLAGS.SHOW_INFANTILE_01]: Boolean(showInfantile01),
  //     })
  //   );
  // });
}
